import React from "react";
import {RegisterValue} from "../../fstn/register";
import {ProjectDetails} from "../../redux/types/firebase";
import {ParameterDescription} from "../../fstn/action";
import SelectMarshalStorage from "./SelectMarshalStorage";

interface Props {
    name: string
    onChangeValue: (key: string, value: RegisterValue | undefined) => void
    parameter: ParameterDescription
    projectDetails: ProjectDetails
    source: string
    value: RegisterValue
}

export default function SelectMarshalVideo({name, onChangeValue, parameter, source, projectDetails, value}: Props) {
    return (
        <SelectMarshalStorage
            name={name} onChangeValue={onChangeValue} parameter={parameter} source={source} value={value as string}
            upload="video/*">
            <video key={value as string} style={{flexGrow: 1}} controls>
                <source src={`${projectDetails.videoSource}/${value as string}`} type="video/mp4"/>
                No valid format
            </video>
        </SelectMarshalStorage>
    );
}